import { NgModule } from '@angular/core';
import { InputAutoCompleteOffDirective } from './input-autocomplete-off.directive';

@NgModule({
    declarations: [InputAutoCompleteOffDirective],
    exports: [InputAutoCompleteOffDirective],
})
export class InputAutoComplateOffModule {}
